import React from "react";

import type { Theme } from "@mui/material";

import { numbers } from "@readai/pulse/theme";
import { px } from "@readai/pulse/utils";

declare module "@mui/material/styles" {
  interface Theme {
    spaces: {
      xxlarge: React.CSSProperties["padding"];
      xlarge: React.CSSProperties["padding"];
      large: React.CSSProperties["padding"];
      base: React.CSSProperties["padding"];
      medium: React.CSSProperties["padding"];
      small: React.CSSProperties["padding"];
      xsmall: React.CSSProperties["padding"];
      xxsmall: React.CSSProperties["padding"];
    };
  }

  interface ThemeOptions {
    spaces?: {
      xxlarge?: React.CSSProperties["padding"];
      xlarge?: React.CSSProperties["padding"];
      large?: React.CSSProperties["padding"];
      base?: React.CSSProperties["padding"];
      medium?: React.CSSProperties["padding"];
      small?: React.CSSProperties["padding"];
      xsmall?: React.CSSProperties["padding"];
      xxsmall?: React.CSSProperties["padding"];
    };
  }
}

const spaces: Theme["spaces"] = {
  xxlarge: px(numbers.numbers.spacing.xxlarge),
  xlarge: px(numbers.numbers.spacing.xlarge),
  large: px(numbers.numbers.spacing.large),
  base: px(numbers.numbers.spacing.base),
  medium: px(numbers.numbers.spacing.medium),
  small: px(numbers.numbers.spacing.small),
  xsmall: px(numbers.numbers.spacing.xsmall),
  xxsmall: px(numbers.numbers.spacing.xxsmall),
};

export default spaces;
